import React from "react";
import { useTranslation } from "react-i18next";

import { List, ListItem, ListIcon, useColorModeValue, Box, Text } from "@chakra-ui/react";
import moment from "moment";
import { IoMdCloseCircle } from "react-icons/io";
import { MdCheckCircle, MdSettings } from "react-icons/md";

export default function AdministrationStatusTooltipLabel({ property, administrationStatus }) {
	const { t } = useTranslation();
	const listItemColor = useColorModeValue("gray.700", "gray.200");
	const listSpacing = "2";

	const getListIcon = (status) => {
		switch (status) {
			case "warning":
				return <ListIcon as={MdSettings} color="orange.400" boxSize={5} />;
			case "complete":
				return <ListIcon as={MdCheckCircle} color="green.400" boxSize={5} />;
			case "incomplete":
				return <ListIcon as={IoMdCloseCircle} color="red.400" boxSize={5} />;
			case "expired":
				return <ListIcon as={IoMdCloseCircle} color="red.400" boxSize={5} />;
			default:
				return <ListIcon as={IoMdCloseCircle} color="red.400" boxSize={5} />;
		}
	};
	return (
		<Box>
			<Text fontSize="sm" fontWeight="bold">
				{t("table.administration")}
			</Text>
			<List spacing={listSpacing}>
				{property.specs.apartmentFeatures.type === "garage" ? (
					<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
						{getListIcon(administrationStatus.administrationContract)}
						{t("types.administrationContract")}
					</ListItem>
				) : (
					<>
						<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
							{getListIcon(administrationStatus.administrationContract)}
							{t("types.administrationContract")}
						</ListItem>
						<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
							{getListIcon(administrationStatus.insurance)}
							{t("types.insurance")}
						</ListItem>
						<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
							{getListIcon(administrationStatus.centralHeatingVerification)}
							{t("types.centralHeatingVerification")}
						</ListItem>
						<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
							{getListIcon(administrationStatus.gasContract)}
							{t("types.gasContract")}
						</ListItem>
						<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
							{getListIcon(administrationStatus.electricityContract)}
							{t("types.electricityContract")}
						</ListItem>
						{property.specs.apartmentFeatures.water === "waterContract" ? (
							<>
								<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
									{getListIcon(administrationStatus.waterContract)} {t("types.waterContract")}
								</ListItem>
								<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
									{getListIcon(administrationStatus.lastWaterInvoice)}
									{t("types.lastWaterInvoice")}
								</ListItem>
							</>
						) : (
							<>
								<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
									{getListIcon(administrationStatus.tenantAssociationCertificate)} {t("types.tenantAssociationCertificate")}
								</ListItem>
								<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
									{getListIcon(administrationStatus.waterAssociation)} {t("types.waterAssociation")}
								</ListItem>
							</>
						)}
						<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
							{getListIcon(administrationStatus.protocol)}
							{t("types.protocol")}
						</ListItem>
						<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
							{getListIcon(administrationStatus.gasAccount)}
							{t("types.gasAccount")}
						</ListItem>
						<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
							{getListIcon(administrationStatus.electricityAccount)}
							{t("types.electricityAccount")}
						</ListItem>
						<ListItem display="flex" alignItems="center" color={listItemColor} fontSize="sm" fontWeight="medium">
							{getListIcon(
								property.owner.identificationDocument.id && moment(property.owner.identificationDocument.expirationDate).unix() > moment().unix()
									? "complete"
									: "incomplete"
							)}
							{t("types.ownerIdentificationDocument")}
						</ListItem>
					</>
				)}
			</List>
		</Box>
	);
}
